import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

TextIconGroup.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string
};

export default function TextIconGroup(props) {
  const {
    title,
    subtitle,
    icon,
    iconSize = 'base',
    iconColor = 'base'
  } = props;

  const header = (
    <div className="space-y-0.5">
      <div className="text-base text-cs-gray-900 font-normal">
        {title}
      </div>
      {subtitle && (
        <div className="text-sm text-cs-gray-500 font-normal">
          {subtitle}
        </div>
      )}
    </div>
  );

  if (icon) {
    return (
      <div className="flex space-x-2">
        <props.icon className={classNames(
          iconSize === 'large' ? 'h-8 w-8' : 'h-6 w-6',
          iconColor === 'yellow' ? 'text-cs-yellow-500' : 'text-cs-gray-900',
        )} />
        {header}
      </div>
    );
  }

  return header;
};
